import styles from "./App.module.scss";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import '@aws-amplify/ui-react/styles.css';

function App(): JSX.Element {
  return (
      <div className={styles.root}>
        <div className={styles.wrapper}>
          <BrowserRouter>
            <div className={styles.page}>
              <Routes />
            </div>
          </BrowserRouter>
        </div>
      </div>
  );
}

export default App;